import api from '@api';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import translate from '@translate';
import {
    validateFileImportFetch as validateFileImportFetchAction,
    validateFileImportFetchSuccess,
    validateFileImportFetchFailure,
    importClaimsFetchSuccess,
    importClaimsFetchFailure,
} from './reducer';
import {
    FileImportType,
    ImportClaimsResType,
    ValidatedClaimImportRowType,
} from 'src/types/claimsImport';
import { FileType } from 'src/types/file';
import { RootStoreType } from 'src/types/store';

export function* addFile(action: { type: string; payload: FileType }): any {
    yield put(validateFileImportFetchAction(action.payload));
}

export function* addFileWatch() {
    yield takeEvery('claimsImport/addFile', addFile);
}

const validateFileImportFetchRequest = async (data: string) => {
    const res = await api('post', 'api/secure/claims/import-validate', { data });
    return res.data.data as ValidatedClaimImportRowType[];
};

function* validateFileImportFetch(action: { type: string; payload: FileType }): any {
    try {
        const response: ValidatedClaimImportRowType[] = yield call((): any =>
            validateFileImportFetchRequest(action.payload.data || '')
        );
        yield put(validateFileImportFetchSuccess({ validation: response, file: action.payload }));
    } catch (e: unknown) {
        const errorMessage =
            e && typeof e === 'object' && 'response' in e
                ? (e as { response?: { data?: { message?: string } } }).response?.data?.message || ''
                : '';
        yield put(validateFileImportFetchFailure({ file: action.payload, errorMessage }));
    }
}

export function* validateFileImportFetchWatch() {
    yield takeEvery('claimsImport/validateFileImportFetch', validateFileImportFetch);
}

const importClaimsFetchRequest = async (rows: ValidatedClaimImportRowType[]) => {
    const res = await api('post', 'api/secure/claims/import-claims', rows);
    return res.data as ImportClaimsResType;
};

function* importClaimsFetch(): any {
    try {
        const files: FileImportType[] = yield select((state: RootStoreType) => state.claimsImport.files);
        const rows: ValidatedClaimImportRowType[] = [];
        files
            .filter((file) => !file.imported && file.validation?.length)
            .forEach((file) => {
                if (file.validation) {
                    rows.push(...file.validation);
                }
            });

        yield call((): any => importClaimsFetchRequest(rows));
        yield put(
            importClaimsFetchSuccess({
                messageSuccess: { title: translate('claims.message.claimsImported') },
            })
        );
    } catch (e: unknown) {
        const errorMessage =
            e && typeof e === 'object' && 'response' in e
                ? (e as { response?: { data?: { message?: string } } }).response?.data?.message || ''
                : '';
        yield put(importClaimsFetchFailure({ errorMessage }));
    }
}

export function* importClaimsFetchWatch() {
    yield takeEvery('claimsImport/importClaimsFetch', importClaimsFetch);
}
